import { useCallback } from 'react';
import { useGetSendEmailSelector } from './useGetSendEmailSelector';

export const useNameSelector = () => {
  const getSendEmail = useGetSendEmailSelector();

  return useCallback((id: string) => getSendEmail(id)?.name, [getSendEmail]);
};
